import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SplashScreen from './pages/PantallaBienvenida';
import PantallaInicio from './components/PantallaInicio';
import PantallaRegistro from './components/PantallaRegistro';
import RecuperarPassword from './components/RecuperarPassword';
import SeleccionarNivel from './components/SeleccionarNivel';
import PantallaBienvenida from './pages/PantallaBienvenida';
import PantallaTutorial from './pages/PantallaTutorial';
import PantallaRepasoIntro from './pages/PantallaRepasoIntro';
import NivelRepaso from './pages/NivelRepaso';
import NivelBasico from './pages/NivelBasico';
import NivelMedio from './pages/NivelMedio';
import NivelAvanzado from './pages/NivelAvanzado';
import VideoFinal from './pages/VideoFinal';


console.log('🧪 Tipo de PantallaTutorial:', typeof PantallaTutorial);
console.log('🧪 Contenido de PantallaTutorial:', PantallaTutorial);

function RutaIndex() {
  const params = new URLSearchParams(window.location.search);
  const modoPruebaVideo = params.get('test') === '1';

  if (modoPruebaVideo) {
    return <VideoFinal />;
  }

  return <PantallaInicio />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PantallaInicio />} />
        <Route path="/index.html" element={<RutaIndex />} />
        <Route path="/registro" element={<PantallaRegistro />} />
        <Route path="/splash" element={<SplashScreen />} />
        <Route path="/recuperar-password" element={<RecuperarPassword />} />
        <Route path="/seleccionar-nivel" element={<SeleccionarNivel />} />
        <Route path="/nivel-repaso" element={<NivelRepaso />} />
        <Route path="/nivel-basico" element={<NivelBasico />} />
        <Route path="/nivel-medio" element={<NivelMedio />} />
        <Route path="/nivel-avanzado" element={<NivelAvanzado />} />
        <Route path="/video-final" element={<VideoFinal />} />
        <Route path="/bienvenida" element={<PantallaBienvenida />} />
        <Route path="/pantallatutorial" element={<PantallaTutorial />} />
        <Route path="/repaso-intro" element={<PantallaRepasoIntro />} />
      </Routes>
    </BrowserRouter>
  );
}

console.log("✅ PantallaTutorial importado:", PantallaTutorial);

export default App;
